import React, { Component } from "react";
import { connect } from "react-redux";
import {
  SLoad,
  SPage,
  SScrollView2,
  SText,
  SInput,
  STheme,
  SView,
  SNotification,
} from "servisofts-component";
import SSocket from "servisofts-socket";

class tablasucursal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      sucursales: [],
      search: "",

      editingKey: null,
      editingValue: "",
      savingKey: null,
    };
  }

  componentDidMount() {
    this.cargarSucursales();
  }

  cargarSucursales() {
    this.setState({ loading: true });

    SSocket.sendPromise({
      component: "sucursal",
      type: "getAll",
      estado: "cargando",
      key_usuario: this.props.state.usuarioReducer.usuarioLog.key,
    })
      .then((resp) => {
        const lista = Object.values(resp.data || {}).filter((e) => e.estado_app == 0 || e.estado_app == 1);
        this.setState({ sucursales: lista, loading: false });
      })
      .catch((e) => {
        console.error(e);
        this.setState({ loading: false });
      });
  }

  getListaFiltrada() {
    const { sucursales, search } = this.state;
    const q = (search || "").toLowerCase().trim();
    if (!q) return sucursales;

    return sucursales.filter((s) => {
      const key = (s.key || "").toLowerCase();
      const desc = (s.descripcion || "").toLowerCase();
      const estadoapp = (s.estado_app).toLowerCase();
      const key_erp = (s.key_erp || "").toLowerCase();
      const tipo= (s.tipo_tienda).toLowerCase();
      return key.includes(q) || desc.includes(q) || estadoapp.includes(q) || key_erp.includes(q)|| tipo.includes(q);
    });
  }

  startEditKeyERP = (item) => {
    const current = (item.key_erp || "").trim();
    this.setState({
      editingKey: item.key,
      editingValue: current === "-" ? "" : current, // si era "-" lo deja vacío para escribir
    });
  };

  guardarKeyERP = async (item) => {
    const value = (this.state.editingValue || "").trim();

    // si quieres permitir "vaciar" el key_erp, quita este if
    if (!value) {
      SNotification?.send?.({ title: "Key ERP", body: "Ingresa un valor.", type: "warning" });
      return;
    }

    // evita doble guardado (blur + enter)
    if (this.state.savingKey === item.key) return;

    this.setState({ savingKey: item.key });

    try {
      await SSocket.sendPromise({
        component: "sucursal",
        type: "editar", 
        data: {
          key: item.key,
          key_erp: value,
        },
      });

      this.setState((prev) => ({
        sucursales: prev.sucursales.map((s) =>
          s.key === item.key ? { ...s, key_erp: value } : s
        ),
        editingKey: null,
        editingValue: "",
        savingKey: null,
      }));

      SNotification?.send?.({ title: "Sucursal", body: "Key ERP guardado ✅", type: "success" });
    } catch (e) {
      console.error(e);
      this.setState({ savingKey: null });
      SNotification?.send?.({ title: "Error", body: "No se pudo guardar Key ERP.", type: "danger" });
    }
  };

  cancelEdit = () => {
    this.setState({ editingKey: null, editingValue: "" });
  };

  renderHeader() {
    const th = {
      padding: 10,
      borderBottomWidth: 1,
      borderBottomColor: STheme.color.card,
    };

    return (
      <SView row style={{ backgroundColor: STheme.color.background }}>
        <SText style={{ ...th, width: 150, fontWeight: "700" }}>Key</SText>
        <SText style={{ ...th, flex: 1, fontWeight: "700" }}>Descripción</SText>
        <SText style={{ ...th, flex: 1, fontWeight: "700" }}>App Estado</SText>
        <SText style={{ ...th, flex: 1, fontWeight: "700" }}>Tipo Tienda</SText>
        <SText style={{ ...th, width: 400, fontWeight: "700" }}>Key ERP</SText>

      </SView>
    );
  }

  renderRow(item) {
    const { editingKey, editingValue, savingKey } = this.state;

    const td = {
      padding: 10,
      borderBottomWidth: 1,
      borderBottomColor: STheme.color.card,
    };

    const isEditing = editingKey === item.key;
    const isSaving = savingKey === item.key;

    return (
      <SView key={item.key} row style={{ alignItems: "center" }}>
        <SText style={{ ...td, width: 150 }} numberOfLines={1}>
          {item.key}
        </SText>

        <SText style={{ ...td, flex: 1 }} numberOfLines={2}>
          {item.descripcion}
        </SText>

        <SText style={{ ...td, flex: 1 }} numberOfLines={1}>
          {item.estado_app == 1 ? "Activo" : "Inactivo"}
        </SText>
        <SText style={{ ...td, flex: 1 }} numberOfLines={1}>
          {item.tipo_tienda == true ? "Activo" : "Inactivo"}
        </SText>

        <SView style={{ ...td, width: 400 }}>
          {isEditing ? (
            <SInput
              placeholder="Key ERP"
              value={editingValue}
              onChangeText={(txt) => this.setState({ editingValue: txt })}
              onSubmitEditing={() => this.guardarKeyERP(item)}
              onBlur={() => this.guardarKeyERP(item)}
              editable={!isSaving}
            />
          ) : (
            <SText
              numberOfLines={1}
              style={{
                color: STheme.color.secondary, // para que se note que es clickeable
              }}
              onPress={() => this.startEditKeyERP(item)}
            >
              {isSaving ? "Guardando..." : (item.key_erp || "-")}
            </SText>
            
          )}
        </SView>
      </SView>
    );
  }

  render() {
    const { loading, search } = this.state;
    const lista = this.getListaFiltrada();

    return (
      <SPage title="Sucursales">


        {loading ? (
          <SLoad />
        ) : (
          <SScrollView2 style={{ padding: 12 }}>
            <SView style={{ borderRadius: 8, overflow: "hidden" }}>
              {this.renderHeader()}
              {lista.map((it) => this.renderRow(it))}
              {lista.length === 0 ? (
                <SView style={{ padding: 12 }}>
                  <SText>No hay sucursales para mostrar.</SText>
                </SView>
              ) : null}
            </SView>
          </SScrollView2>
        )}
      </SPage>
    );
  }
}

export default connect((state) => ({ state }))(tablasucursal);
